import { useEffect, useState } from "react";

const COLORS = ["#FF5A36", "#FFC400", "#29C7E8", "#7CE645", "#FF4D9D"];

let nextBurstId = 0;

export const useConfetti = () => {
  const [bursts, setBursts] = useState([]);

  const fire = (count = 28) => {
    const id = ++nextBurstId;
    const pieces = Array.from({ length: count }).map((_, i) => ({
      id: `${id}-${i}`,
      left: 10 + Math.random() * 80,
      dx: (Math.random() - 0.5) * 40,
      dur: 1.4 + Math.random() * 1.2,
      delay: Math.random() * 0.15,
      color: COLORS[i % COLORS.length],
      rotate: Math.random() * 360,
    }));
    setBursts((prev) => [...prev, { id, pieces }]);
    setTimeout(() => {
      setBursts((prev) => prev.filter((b) => b.id !== id));
    }, 3000);
  };

  const ConfettiLayer = () => (
    <div aria-hidden className="pointer-events-none">
      {bursts.map((b) =>
        b.pieces.map((p) => (
          <span
            key={p.id}
            className="confetti-piece"
            style={{
              left: `${p.left}vw`,
              "--x": `0px`,
              "--dx": `${p.dx}vw`,
              "--dur": `${p.dur}s`,
              animationDelay: `${p.delay}s`,
              backgroundColor: p.color,
              transform: `rotate(${p.rotate}deg)`,
            }}
          />
        ))
      )}
    </div>
  );

  return { fire, ConfettiLayer };
};
